// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.process {
  position: relative;
  background:
    linear-gradient(180deg, rgba(15, 46, 36, 0.04), transparent 30%),
    linear-gradient(135deg, var(--mist) 0%, var(--sand) 55%, var(--paper) 100%);
}

.process::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--line), transparent);
  animation: pulse-line 4s ease-in-out infinite;
}

.process__intro {
  margin-bottom: clamp(2.5rem, 6vw, 3.75rem);
}

.process__steps {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: clamp(1.5rem, 4vw, 2.5rem);
  counter-reset: none;
}

.process__step {
  position: relative;
  padding-top: 0.25rem;
}

.process__step:not(:last-child)::after {
  content: '';
  position: absolute;
  top: 1.15rem;
  right: -1.1rem;
  width: calc(100% - 3.5rem);
  height: 1px;
  background: linear-gradient(90deg, rgba(15, 46, 36, 0.2), transparent);
}

.process__number {
  display: block;
  margin-bottom: 1rem;
  font-family: var(--font-display);
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.12em;
  color: var(--moss);
}

.process__title {
  max-width: 12ch;
  font-family: var(--font-display);
  font-size: clamp(1.2rem, 2vw, 1.45rem);
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: -0.03em;
  color: var(--ink);
}

.process__text {
  max-width: 28ch;
  margin-top: 0.75rem;
  color: var(--muted);
}

@media (max-width: 860px) {
  .process__steps {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .process__step:not(:last-child)::after {
    display: none;
  }

  .process__step {
    padding-bottom: 2rem;
    border-bottom: 1px solid var(--line);
  }

  .process__step:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Process.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB;;+EAE6E;AAC/E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,WAAW;EACX,yEAAyE;EACzE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,WAAW;EACX,sEAAsE;AACxE;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":[".process {\r\n  position: relative;\r\n  background:\r\n    linear-gradient(180deg, rgba(15, 46, 36, 0.04), transparent 30%),\r\n    linear-gradient(135deg, var(--mist) 0%, var(--sand) 55%, var(--paper) 100%);\r\n}\r\n\r\n.process::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 0;\r\n  height: 1px;\r\n  background: linear-gradient(90deg, transparent, var(--line), transparent);\r\n  animation: pulse-line 4s ease-in-out infinite;\r\n}\r\n\r\n.process__intro {\r\n  margin-bottom: clamp(2.5rem, 6vw, 3.75rem);\r\n}\r\n\r\n.process__steps {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style: none;\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: clamp(1.5rem, 4vw, 2.5rem);\r\n  counter-reset: none;\r\n}\r\n\r\n.process__step {\r\n  position: relative;\r\n  padding-top: 0.25rem;\r\n}\r\n\r\n.process__step:not(:last-child)::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 1.15rem;\r\n  right: -1.1rem;\r\n  width: calc(100% - 3.5rem);\r\n  height: 1px;\r\n  background: linear-gradient(90deg, rgba(15, 46, 36, 0.2), transparent);\r\n}\r\n\r\n.process__number {\r\n  display: block;\r\n  margin-bottom: 1rem;\r\n  font-family: var(--font-display);\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0.12em;\r\n  color: var(--moss);\r\n}\r\n\r\n.process__title {\r\n  max-width: 12ch;\r\n  font-family: var(--font-display);\r\n  font-size: clamp(1.2rem, 2vw, 1.45rem);\r\n  font-weight: 600;\r\n  line-height: 1.2;\r\n  letter-spacing: -0.03em;\r\n  color: var(--ink);\r\n}\r\n\r\n.process__text {\r\n  max-width: 28ch;\r\n  margin-top: 0.75rem;\r\n  color: var(--muted);\r\n}\r\n\r\n@media (max-width: 860px) {\r\n  .process__steps {\r\n    grid-template-columns: 1fr;\r\n    gap: 2rem;\r\n  }\r\n\r\n  .process__step:not(:last-child)::after {\r\n    display: none;\r\n  }\r\n\r\n  .process__step {\r\n    padding-bottom: 2rem;\r\n    border-bottom: 1px solid var(--line);\r\n  }\r\n\r\n  .process__step:last-child {\r\n    padding-bottom: 0;\r\n    border-bottom: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
